// src/utils/assistantRestaurantLink.js
import { buildRestaurantUrl } from '@/pages/home-restaurant-discovery/restaurantUrl';

/**
 * The /restaurant/:id link for an assistant navigation or chat card.
 *
 * The assistant stream carries the RESOLVED fulfillment intent (service,
 * address, coords, asap or date/time, meal type — see the server's
 * resolveRestaurantFulfillment) next to a fallback `path`. Rebuilding the link
 * here with the discovery builder means a chat-opened page carries exactly
 * what a discovery card does: lat/lng (no re-geocode, and the DoorDash
 * saved-address matcher has coords from the first render), asap=1 for a
 * "now" request, and whenISO for a scheduled one.
 */
export function buildAssistantRestaurantPath({ restaurantId, fulfillment, path } = {}) {
  const id = typeof restaurantId === 'string' ? restaurantId.trim() : '';
  const fallback = typeof path === 'string' && path.startsWith('/') ? path : '';
  if (!id || !fulfillment || typeof fulfillment !== 'object') return fallback;

  const lat = Number(fulfillment.coords?.lat);
  const lng = Number(fulfillment.coords?.lng);
  const coords = Number.isFinite(lat) && Number.isFinite(lng) ? { lat, lng } : null;
  const service =
    fulfillment.service === 'pickup' || fulfillment.service === 'delivery' ? fulfillment.service : null;

  return buildRestaurantUrl({
    restaurantId: id,
    selectedService: service,
    fulfillment: {
      address: fulfillment.address || null,
      coords,
      date: fulfillment.date || null,
      time: fulfillment.time || null,
      asap: fulfillment.asap === true,
    },
    mealType: fulfillment.mealType || null,
  });
}
